import Vue from 'vue'
const mutations= {
  SET_STORE_LANGUAGE(state, storeLanguage){
    state.storeLanguage = storeLanguage;
  }
};
export default mutations



// WEBPACK FOOTER //
// ./src/vuex/mutations.js